module.exports = __webpack_public_path__ + "img/nav_logo1.bde8cb9a.png";